/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query'
import type {
  ExternalAuthRequestDto,
  ExternalAuthResponseDto,
  HTTPValidationError
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 플랫폼로그인정보로연동된API-KEY를가져오는API
 * @summary GetApiKeyWithCustomerLogin
 */
export const getApiKeyWithCustomerLogin = (
    externalAuthRequestDto: ExternalAuthRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<ExternalAuthResponseDto>(
      {url: `/external/auth/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: externalAuthRequestDto
    },
      options);
    }
  


export const getGetApiKeyWithCustomerLoginMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getApiKeyWithCustomerLogin>>, TError,{data: ExternalAuthRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof getApiKeyWithCustomerLogin>>, TError,{data: ExternalAuthRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getApiKeyWithCustomerLogin>>, {data: ExternalAuthRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  getApiKeyWithCustomerLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetApiKeyWithCustomerLoginMutationResult = NonNullable<Awaited<ReturnType<typeof getApiKeyWithCustomerLogin>>>
    export type GetApiKeyWithCustomerLoginMutationBody = ExternalAuthRequestDto
    export type GetApiKeyWithCustomerLoginMutationError = HTTPValidationError

    /**
 * @summary GetApiKeyWithCustomerLogin
 */
export const useGetApiKeyWithCustomerLogin = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getApiKeyWithCustomerLogin>>, TError,{data: ExternalAuthRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof getApiKeyWithCustomerLogin>>,
        TError,
        {data: ExternalAuthRequestDto},
        TContext
      > => {

      const mutationOptions = getGetApiKeyWithCustomerLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    